export default {
    createBlacklistText: 'Create Blacklist',
    updateBlacklistText: 'Update Blacklist',
    name: 'Name',
    surname: 'Surname',
    save: 'Save',
    cancel: 'Cancel',
    msgImageSize: 'Image size must be between 25KB and 200KB',
    msgErrorImageSize: 'Image size can not be less than 25KB or more than 200KB',
    msgError: 'Error Message',
    profile: 'Profile',
    gender: 'Gender',
    male: 'Male',
    female: 'Female',
    msgRequiredField: 'This field is required',
    msgExceededField: 'This field is exceeded 255 characters',
    reason: 'Blacklist reason (Optional)',
    writeReason: 'Write the reason',
    status: 'Status',
    errorNoImage: 'Please select a photo'
}
